// extracted by mini-css-extract-plugin
module.exports = {"notice":"NoticeComponent_notice__3yn-k","icon":"NoticeComponent_icon__u1Es1","info":"NoticeComponent_info__3UKAX"};